import React from "react";
import DestinationList from "./DestinationList";
import AddDestination from "./AddDestination";

const DestinationIndex = () => {
  return (
    <div className="text-white-50">
      <h1 className="text-success text-center">Travel List</h1>
      <AddDestination />
      <DestinationList />
    </div>
  );
};

export default DestinationIndex;
